export enum LayerKind {
  statisticZoneStrength = 'statisticZoneStrength',
  statisticZoneStrengthDelta = 'statisticZoneStrengthDelta',
  statisticZoneStrengthRank = 'statisticZoneStrengthRank',
  statisticYieldRank = 'statisticYieldRank',
  statisticYieldSoilParameter = 'statisticYieldSoilParameter',

  stemNumber = 'stemNumber',
  yieldValue = 'yieldValue',
  yieldVsStemNumber = 'yieldVsStemNumber',

  yieldVsK = 'yieldVsK',
  yieldVsP = 'yieldVsP',
  yieldVsN = 'yieldVsN',

  decisionSupportEstimatedRevenue = 'decisionSupportEstimatedRevenue',
  decisionSupportEstimatedIncome = 'decisionSupportEstimatedIncome',
  decisionSupportCropPrice = 'decisionSupportCropPrice',
  decisionSupportUpkeepCost = 'decisionSupportUpkeepCost',

  heightMapAssignedLines = 'heightMapAssignedLines',
  heightMapAssignedArea = 'heightMapAssignedArea',

  heightMapCandidateLines = 'heightMapCandidateLines',
  heightMapCandidateArea = 'heightMapCandidateArea'
}
